// CHANGE-card: every customer-facing string for the card's early-access request, in one place, so a rename is a
// one-line change here. Wording rules (founder and research.md 3.9): it's a request for early access, never a credit
// decision. Visible copy never says apply, approved or eligible (the legal notice from the server is the only place
// "application" appears), and never a present-tense rate. The form's questions, the notice and the planned-points
// sentence come from the server (pr/card/fields.py copy(), rates in pr/card/rewards.py).

export const NAME = 'ernd card'
export const TITLE = 'Request early access to the ernd card'
export const SHORT = 'Request early access'          // entry buttons and the menu
export const START = 'Start request'
export const SEND = 'Send request'
// founder, 2026-10-27: "dont say it isnt available yet. Just say we're issuing in a first-come-first-served basis"
export const INTRO = "We're issuing cards on a first-come, first-served basis. Submit your application below."
export const SAVED = 'Saved'
// CHANGE-054: before Continue nothing is on the server yet, so the first screen is kept in this browser
export const SAVED_HERE = 'Saved on this device'
// CHANGE-063: an answer that can't go up as it stands, and a save waiting for the connection
export const NOT_SAVED = 'Not saved yet'
export const RETRYING = 'Not saved yet. Trying again.'
export const OFF = "Early access to the ernd card isn't open right now."
export const ADMIN_ONLY = 'Only a company admin can send this request. Ask an admin on your team.'
export const CONTINUE = 'Continue your request'
export const SEE = 'See your request'
export const KEEP = 'Keep my request'
export const KEEP_LINE = "Your request is 18 months old and we haven't issued your card yet. Keep it, or we'll delete it in 30 days."
export const STILL_NEEDED = 'Still needed before you can send'

export const STATE: Record<string, string> = {
  draft: 'Not sent yet',
  received: 'Request received',
  invited: 'Ready for the next step',
  withdrawn: 'Withdrawn',
}

// The card home's one status line (founder, 2026-10-31)
export const STATE_LINE: Record<string, string> = {
  none: 'Not started.',
  draft: 'Your request is saved but not sent yet.',
  received: 'Your request is sent.',
  invited: 'The ernd card is ready for your company. Check your email for the next step.',
}

// The invite link on Profile (CHANGE-065). Unpaid, so nothing here promises a reward.
export const INVITE = 'Know another founder who should have it?'
export const INVITE_COPY = 'Copy link'
export const INVITE_COPIED = 'Copied'

export const ENTRY: Record<string, string> = {
  none: 'Request early access to the ernd card. It takes a few minutes, and we fill in what ernd already knows.',
  member: 'A company admin can request early access to the ernd card.',
  draft: 'Your request is saved but not sent yet.',
  received: "Request received. We'll email you when the card is ready for your company.",
  invited: 'The ernd card is ready for your company.',
}

// Someone whose work-email domain already has a company on ernd (founder, 2026-10-27: one request per company)
export const SAME_DOMAIN_TITLE = (names: string) => `${names} is already on ernd`
export const SAME_DOMAIN_BODY = (domain: string) => `Someone with an @${domain} email set it up. ernd takes one request per company, sent by one of its admins. If this is your company, ask the person who set it up to send the request or check on it.`
export const SAME_DOMAIN_CONTINUE = "I'm with a different company"
